import {
    UNIDADE_MEDIDA_MODO_TELA,
    UNIDADE_MEDIDA_SET_AGUARDANDO,
    UNIDADE_MEDIDA_LISTADO
} from './unidadeMedidaActions';

const INITIAL_STATE = {
    registro: {},
    modoTela: 'lista',
    aguardando: false,
    lista: [],
    listaSelect: []
};

export default (state = INITIAL_STATE, action) => {

    switch (action.type) {

        case UNIDADE_MEDIDA_MODO_TELA:
            return {
                ...state,
                modoTela: action.payload.modo,
                registro: action.payload.registro || {}
            };

        case UNIDADE_MEDIDA_SET_AGUARDANDO:
            return {
                ...state,
                aguardando: action.payload
            };

        case UNIDADE_MEDIDA_LISTADO: {

            const lista = action.payload.data || [];

            return {
                ...state,
                lista,
                listaSelect: lista.map(item => ({
                    id: item.id,
                    valor: `${item.nome} (${item.sigla})`
                }))
            };
        }

        default:
            return state;

    }

};